import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import PropTypes from "prop-types";
import ProjectCard from "../ProjectCard";
import { ReactComponent as ArrowLeftCircleSvg } from "../../assets/newProject/arrow-left-circle.svg";
import { ReactComponent as ArrowRightCircleSvg } from "../../assets/newProject/arrow-right-circle.svg";

const MoreBy = ({ title, works, delay, key }) => {
  const [_, setInit] = useState();
  if (!works || works.length === 0) {
    return <></>;
  }

  return (
    <div className="project-view-content-container-more">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span className="project-view-content-container-more__header">
          {title}
        </span>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <ArrowLeftCircleSvg
            className={`project-view-content-container-more__arrow--${key}--left`}
            width={36}
          />
          <ArrowRightCircleSvg
            className={`project-view-content-container-more__arrow--${key}--right`}
            width={36}
          />
        </div>
      </div>
      <Swiper
        className="project-view-content-container-more-gallery"
        modules={[Autoplay, Pagination, Navigation]}
        slidesPerView={2}
        spaceBetween={20}
        // autoplay={{
        //   delay,
        //   pauseOnMouseEnter: true,
        // }}
        loop={true}
        // speed={500}
        breakpoints={{
          768: {
            slidesPerView: 3,
          },
          1252: {
            slidesPerView: 4,
          },
        }}
        pagination={{
          clickable: true,
        }}
        observer={true}
        observeParents={true}
        navigation={{
          enabled: true,
          prevEl: `.project-view-content-container-more__arrow--${key}--left`,
          nextEl: `.project-view-content-container-more__arrow--${key}--right`,
        }}
        onInit={() => setInit(true)}
      >
        {works.map((w, i) => {
          return (
            <SwiperSlide key={`moreby-${i}`}>
              <ProjectCard {...w} />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

MoreBy.propTypes = {
  title: PropTypes.string.isRequired,
  works: PropTypes.array,
};

MoreBy.defaultProps = {
  works: [],
};

export default MoreBy;
